export enum BannerType {
  PRIMARY_HOME,
  SECUDARY_HOME,
  SERVICE_HOME,
  MIDLE_HOME,
}
